import { Loader } from 'lucide-react';

/**
 * The single, app-wide bootstrap loader. Used everywhere the app is
 * starting up / exchanging a session (route bootstrap, embed bootstrap,
 * etc.) so the spinner is identical in every entry point — one loader,
 * never multiple competing ones. Always Lucide `<Loader />` (not `Loader2`).
 */
export const LoadingOverlay = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      <Loader className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};
